import { IZipCodeResponse, IZipCodeData, IZipCodeRequest } from '../lib/interfaces/IZipCode.interface';
import { CreditApplication } from '../lib/interfaces/credit-application.interface';
import { PreQualificationResponseType } from '../lib/interfaces/prequalification-response.interface';

export const ZipCodeDataMock: IZipCodeData = {
  PostalCode: '33304',
  StateCode: 'FL',
  City: 'Fort Lauderdale',
  Latitude: 110.345,
  Longitude: 123.456,
  ValidPostalCode: true
};

export const ZipCodeResponseMock: IZipCodeResponse = {
  Success: true,
  ErrorCodes: [],
  ZipCodeData: ZipCodeDataMock
};

export const ZipCodeRequestMock: IZipCodeRequest = {
  zipCode: '33304'
};

export const ZipCodeResponseFailMock: IZipCodeResponse = {
  Success: false,
  ErrorCodes: [{ Code: 'ERRCODE 06/17/2019 23:21:45', Message: 'Zipcode You Entered is not Valid' }],
  ZipCodeData: {
    PostalCode: null,
    StateCode: null,
    City: null,
    Latitude: 0.0,
    Longitude: 0.0,
    ValidPostalCode: false
  }
};

export const PreQualificationResponseMock : PreQualificationResponseType = {
   IsSuccess: true,
   StatusCode: 200,
   Message: 'test',
   Data: null
}

// tslint:disable-next-line: max-line-length
export const CreditAppResponseMock: CreditApplication = {
  creditAppId: 'e41921d4-e353-4abe-b734-03601a14bebf',
  opptId: 71755129,
  coBuyer: {
     relationshipToApplicant: 1,
     personalInformation: {
        firstName: 'dfgdfg',
        lastName: 'dgdfgdfg',
        middleName: 'd',
        phoneNumber: '3453453453',
        emailAddress: 'dfg@qwqw.com',
        currentAddress: {
           addressLine1: '8665 Saddlebrook Cir Apt 7104',
           addressLine2: '',
           city: 'Naples',
           stateCode: 'FL',
           postalCode: '34104',
           yearsAtAddress: 4,
           monthsAtAddress: 3
        },
        previousAddress: [
           {
              addressLine1: 'fghfghfg',
              addressLine2: 'hdfgdfg',
              city: 'Fort Lauderdale',
              postalCode: '33301',
              stateCode: 'FL',
              yearsAtAddress: 6,
              monthsAtAddress: 2
           }
        ],
        preQualAmount: 0,
        sameAddresAsApplicant: true
     },
     financialInformation: {
        securityInformation: {
           dob: '12/12/1986',
           dobMonth: null,
           dobDate: null,
           dobYear: null,
           ssn: '456456456',
           ssn1: '456',
           ssn2: '45',
           ssn3: '6456',
           verifySsn1: null,
           verifySsn2: null,
           verifySsn3: null
        },
        residenceInformation: {
           residenceType: 0,
           monthlyMortgageAmount: '567',
           mortgageCompany: null,
           yearsAtAddress: 7,
           monthsAtAddress: 7
        },
        currentEmployer: {
           employmentStatus: 'ActiveMilitary',
           jobType: 'Craftsman',
           employerName: 'hfghfgh',
           jobTitle: 'fghfgh',
           phoneNumber: '5675675675',
           yearsAtEmployer: 0,
           monthsAtEmployer: 2,
           salary: '456456',
           frequency: 'Yearly'
        },
        previousEmployer: {
           employmentStatus: 'Contract',
           jobType: 'Homemaker',
           employerName: 'fghfgh',
           jobTitle: 'ghfhfgh',
           phoneNumber: '4564564564',
           yearsAtEmployer: 14,
           monthsAtEmployer: 2,
           salary: '456456',
           frequency: 'Weekly'
        },
        otherIncomeInformation: {
           otherIncomeType: 'Family Subsistence Supplemental Allowance (FSSA)',
           frequency: 'Weekly',
           explain: null,
           amount: '456'
        },
        hasOtherIncome: false
     },
     educationalInformation: {

     },
     consentIndicator: true,
     authorizationConsent: false,
     initials: 'sdf'
   },
  managerInitials: 'cvb',
  buyerFullName: '',
  coBuyerFullName: '',
  reasonForChange: null,
  shortForm: {
     disclaimers: null,
     personalInformation: {
        firstName: 'Christopher',
        lastName: 'Ruizaa',
        middleName: '',
        phoneNumber: '239-404-3260',
        emailAddress: 'sdfsd@qwqw.com',
        dateOfBirth: '12/12/1986',
        ssn: '123-45-9875',
        income: 80000,
        monthlyMortgage:4000,
        currentAddress: {
           addressLine1: '8665 Saddlebrook Cir Apt 7104',
           addressLine2: '',
           city: 'Naples',
           stateCode: 'FL',
           postalCode: '34104',
           yearsAtAddress: 4,
           monthsAtAddress: 3
        },
        previousAddress: [
           {
              addressLine1: 'fddfgdfg',
              addressLine2: 'd',
              city: 'Fort Lauderdale',
              stateCode: 'FL',
              postalCode: '33330',
              yearsAtAddress: 3,
              monthsAtAddress: 2
           }
        ]
     },
     tradeInInfo: {
        applyTrade: false,
        applyTradeFullValue: false,
        applyTradeAmount: 0,
        tradePayoff: 0,
        tradeValue: 0,
        missingTitle: false,
        openTradeDmvFees: 0,
        inServiceDate: null,
        inceptionMiles: 0
     },
     surveyQuestions: null,
     intendedUse: 1,
     paymentOption: 2,
     cashDown: '456',
     vehicleInformation: {
        vin: 'WDDHF5GB4AA065795',
        year: 2010,
        make: 'Mercedes-Benz',
        model: 'E-Class',
        trim: 'E 350 Sport',
        stockType: 'USED',
        hyperionId: null,
        stockNo: null
     },
     qualificationTemplates: {
        qualified: null,
        notQualified: ''
     },
     enablePreQualification: false,
     dealParameters: {
        sceId: null,
        sceUserId: null,
        sceVehicleOfInterestId: 0,
        userId: null,
        creditAppId: 'e41921d4-e353-4abe-b734-03601a14bebf',
        parentCreditAppId: null,
        opptId: 71755129,
        opptVehicleId: 0,
        creditShortFormId: null,
        creditFormId: 'ad3b58cc-752f-49dc-9f34-7cc52f5f7339',
        tradeInVehicleId: null,
        paymentCalculatorId: null
     },
     userName: 'pepe',
     bookValue: 0,
     vehiclePayment: null,
     viewType: 0,
     siteId: 0,
     microsoftLocaleId: 0,
     isoLanguage: null,
     voiInceptionMiles: 88500,
     validationErrors: [

     ]
  },
  hasCoBuyer: true,
  buyerHasOtherIncome: true,
  buyerAuthorizationConsent: true,
  coBuyerHasOtherIncome: true,
  coBuyerAuthorizationConsent: true,
  sameAddresAsApplicant: true,
  regulationsConsent: false,
  managerConsent: false,
  buyerRegulationBConsent: true,
  coBuyerRegulationBConsent: true,
  communityPropertyConsent: false,
  step: 1,
  creditApplicationStatus: 'NotStarted',
  creditApplicationCompleted: false,
  siteId: 10000,
  microsoftLocaleId: 1033,
  sceId: null,
  sceUserId: null,
  sceVehicleOfInterestId: 0,
  userId: null,
  buyer: {
     personalInformation: {
        firstName: 'Christopher',
        lastName: 'Ruizaa',
        middleName: '',
        phoneNumber: '239-404-3260',
        emailAddress: 'sdfsd@qwqw.com',
        dateOfBirth: '12/12/1986',
        income : 80000,
        monthlyMortgage: 4000,
        currentAddress: {
           addressLine1: '8665 Saddlebrook Cir Apt 7104',
           addressLine2: '',
           city: 'Naples',
           stateCode: 'FL',
           postalCode: '34104',
           yearsAtAddress: 4,
           monthsAtAddress: 3
        },
        previousAddress: [
           {
              addressLine1: 'fddfgdfg',
              addressLine2: 'd',
              city: 'Fort Lauderdale',
              stateCode: 'FL',
              postalCode: '33330',
              yearsAtAddress: 2,
              monthsAtAddress: 2
           }
        ]
     },
     financialInformation: {
        securityInformation: {
           dob: '12/12/1986',
           ssn: '234232342',
           ssn1: '234',
           ssn2: '23',
           ssn3: '2342',
           dobMonth: 12,
           dobDate: 12,
           dobYear: 1986
        },
        residenceInformation: {
           residenceType: 1,
           monthlyMortgageAmount: '4533'
        },
        currentEmployer: {
           employmentStatus: 2,
           jobType: 'Homemaker',
           employerName: 'fgfhfgh',
           jobTitle: 'ddfgdfg',
           phoneNumber: '4564564545',
           yearsAtEmployer: 23,
           monthsAtEmployer: 3,
           salary: '43523',
           frequency: 3
        },
        previousEmployer: null,
        otherIncomeInformation: {
           amount: '45645',
           frequency: 'Weekly',
           otherIncomeType: 'Municipal Bond Interest'
        }
     },
     educationalInformation: null,
     consentIndicator: false,
     initials: 'fdg'
  },
  voi: {
     vin: 'WDDHF5GB4AA065795',
     year: 2010,
     make: 'Mercedes-Benz',
     model: 'E-Class',
     trim: 'E 350 Sport',
     stockType: 'USED',
     hyperionId: '2269',
     chromeStyleId: null,
     isPrimary: false,
     stockNo: null,
     voiInceptionMiles: 88500,
     showVoiPreview: true,
     photo: '//az336639.vo.msecnd.net/actualcdn/cd1837fd32a4539faaed90f11fa711e2_392x294_V4.jpg',
     ANPrice: 13000,
     InventoryStatus: 'In Stock',
     Mileage: 88500
  },
  disclaimers: {
     preQualAgreement: '',
     preQualifiedDisclaimer: '',
     notQualifedDisclaimer: '',
     // tslint:disable-next-line: max-line-length
     buyerAuthorization: 'By clicking Submit and Review below, you certify that you have completed this application to obtain credit, and that all information provided by you for this application is true, correct and complete. You understand and agree that this application and related credit information may be used by us to obtain your credit report and may be forwarded to one or more financial institutions for the purpose of obtaining credit for you and such financial institution may be asked to buy the retail installment contract or lease involved in this transaction. You authorize us to share the results of any credit report, credit investigation, or employment investigation (including the information contained in this application) with the financial institutions with which we normally transact business and any other person to assist us in obtaining an extension of credit for you. You also authorize us to receive copies of such reports and investigations to search for financing with third party lenders on your behalf. You authorize us and our third party lenders to make inquiries and obtain information about you as we deem appropriate, including contacting your credit references and/or your employer, investigating your credit and employment history. If you provided your e-mail address on this application, you agree that any communications and correspondence to you from any of the parties to this transaction may be effected by e-mail and you expressly consent to us and our affiliates using prerecorded/artificial voice messages, text messages and/or automatic dialing equipment to communicate with you regarding this application or your vehicle transaction and you agree that we may take these actions using the telephone number(s) that you provide us in this credit application, you provide to us in the future, even if the number is for a mobile telephone and/or our using the number results in charges to you.',
     // tslint:disable-next-line: max-line-length
     coBuyerAuthorization: 'By clicking Submit and Review below, you certify that you have completed this application to obtain credit, and that all information provided by you for this application is true, correct and complete. You understand and agree that this application and related credit information may be used by us to obtain your credit report and may be forwarded to one or more financial institutions for the purpose of obtaining credit for you and such financial institution may be asked to buy the retail installment contract or lease involved in this transaction. You authorize us to share the results of any credit report, credit investigation, or employment investigation (including the information contained in this application) with the financial institutions with which we normally transact business and any other person to assist us in obtaining an extension of credit for you. You also authorize us to receive copies of such reports and investigations to search for financing with third party lenders on your behalf. You authorize us and our third party lenders to make inquiries and obtain information about you as we deem appropriate, including contacting your credit references and/or your employer, investigating your credit and employment history. If you provided your e-mail address on this application, you agree that any communications and correspondence to you from any of the parties to this transaction may be effected by e-mail and you expressly consent to us and our affiliates using prerecorded/artificial voice messages, text messages and/or automatic dialing equipment to communicate with you regarding this application or your vehicle transaction and you agree that we may take these actions using the telephone number(s) that you provide us in this credit application, you provide to us in the future, even if the number is for a mobile telephone and/or our using the number results in charges to you.',
     buyerRegulationBDisclaimer: 'We intend to apply for joint credit',
     coBuyerRegulationBDisclaimer: 'We intend to apply for joint credit',
     // tslint:disable-next-line: max-line-length
     communityPropertyDisclaimer: 'If you are married and live in a community property state please complete the Buyer section about yourself and the Co-Buyer section about your spouse. You must agree to submit this application and your spouse must agree to submit the application only if she/he wishes to be a Co-Applicant.',
     jointCreditDisclaimer: 'We intend to apply for joint credit'
  },
  qualificationTemplates: null,
  enableExperian: false,
  providerId: null,
  sceLeadSource: 'DSF',
  hideVoi: false,
  voiInceptionMiles: 88500,
  opptVehicleId: 0,
  tradeInVehicleId: 0,
  creditFormId: 'ad3b58cc-752f-49dc-9f34-7cc52f5f7339'
};

